<template>
    <div class="new">
        <div class="vcore_row">
            <div class="vcore_col--md--12 title">New Project Details</div>
        </div>
        <div class="vcore_row">
            <div class="vcore_col--md--12">
                <FormPrototype :newProject=true />
            </div>
        </div>
        <div class="vcore_row">
            <div class="vcore_col--md--6"></div>
            <div class="vcore_col--md--6">
                <button
                        class="vcore_btn md-button blue-button"
                        type="button"
                        @click="addNewPrototype"
                >Add</button>
                <button
                        class="vcore_btn md-button red-button"
                        type="button"
                        @click="back"
                >Cancel</button>
            </div>
        </div>


    </div>
</template>

<script>
    import FormPrototype from "@/components/FormPrototype";
    import { mapActions } from "vuex";

    export default {
        name: "NewPrototype",
        components: {
            FormPrototype,
        },
        methods: {
            ...mapActions([
                "createPrototype"
            ]),
            addNewPrototype(){
                this.$store.commit("updateUpdate", Date.now());
                this.createPrototype()
                    // eslint-disable-next-line no-unused-vars
                    .then(result => {
                        window.alert("Prototype successfully submitted.");
                        this.$router.push("/");
                        this.$store.dispatch('clearPrototype');
                    })
                    .catch(error => {
                        window.alert("There was an error during submission. " + error);
                    })
            },
            back(){
                this.$router.push("/");
            }
        },
        mounted() {
            this.$store.dispatch("clearPrototype");
        }
    }
</script>

<style scoped lang="scss">
    .new {
        margin-top: 50px;
    }

    .title {
        font-family: "Open Sans", sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 35px;
        text-align: left;
        color: #666666;
        padding-bottom: 15px;
    }

    .vcore_btn {
        float: right;
        margin-left: 10px;
    }

    .md-button {
        font-size: 16px;
        font-weight: 600;
        padding: 10px 30px;
        min-width: 150px;
    }

</style>
